import { render, staticRenderFns } from "./InputMedia.vue?vue&type=template&id=461ad26a&scoped=true&"
import script from "./InputMedia.vue?vue&type=script&lang=ts&"
export * from "./InputMedia.vue?vue&type=script&lang=ts&"
import style0 from "./InputMedia.vue?vue&type=style&index=0&id=461ad26a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461ad26a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VFileInput,VSelect,VTextField,VTextarea})
